import "core-js/modules/es6.function.name";
//
//
//
//
import echarts from 'echarts';
import tdTheme from './theme.json';
import { on, off } from '@/libs/tools';
echarts.registerTheme('tdTheme', tdTheme);
export default {
  name: 'ChartLine',
  props: {
    value: Object,
    text: String,
    lineName: String,
    subtext: String,
    legend: Array,
    series: Array,
    xAxis: Array
  },
  data: function data() {
    return {
      dom: null,
      option: {},
      index: 0
    };
  },
  watch: {
    series: {
      handler: function handler(newVal, oldVal) {
        if (this.dom) {
          if (newVal) {
            this.getDataInit(newVal);
          } else {
            this.getDataInit(oldVal);
          }
        } else {
          this.init();
        }
      },
      deep: true
    }
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },
    setOption: function setOption() {
      var option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        legend: {
          data: this.legend,
          selected: {
            '报警信息': true,
            '触发数据': false
          },
          selectedMode: 'single' //单选

        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.series.length > 0 ? this.series[0].xaxis : [] // axisLabel:{
          //   interval:0,
          //   rotate:40
          // }

        },
        yAxis: {
          type: 'value'
        },
        series: this.series
      };
      return option;
    },
    //高温与还原
    setOption1: function setOption1() {
      var option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        legend: {
          data: this.legend,
          selected: {
            '报警数据': false,
            '触发数据': true
          },
          selectedMode: 'single' //单选

        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.series.length > 0 ? this.series[1].xaxis : [] // axisLabel:{
          //   interval:0,
          //   rotate:40
          // }

        },
        yAxis: {
          type: 'value'
        },
        series: this.series
      };
      return option;
    },
    getDataInit: function getDataInit() {
      var index = this.index;

      if (index === 0) {
        this.dom.setOption(this.setOption());
      } else if (index === 1) {
        this.dom.setOption(this.setOption1());
      } else {
        this.dom.setOption(this.setOption());
      }
    },
    init: function init() {
      var _this = this;

      this.dom = echarts.init(this.$refs.dom, 'tdTheme');
      this.dom.showLoading();
      this.dom.setOption(this.setOption());
      this.dom.hideLoading();
      this.dom.on('legendselectchanged', function (res) {
        var index = _this.legend.indexOf(res.name);

        _this.index = index;

        if (index === 0) {
          _this.dom.setOption(_this.setOption());
        } else if (index === 1) {
          _this.dom.setOption(_this.setOption1());
        }
      });
      on(window, 'resize', this.resize);
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};